import { call, put, takeLatest } from "@redux-saga/core/effects";
import { getUserInFo } from "../../helpers/backend_helper";
import { getUserInfoFailed, getUserInfoSuccess } from "./actions";
import { GET_USER_INFO} from "./actionsTypes";

function* onGetUserInfo({ payload: params }) {
  try {
    const response = yield call(getUserInFo, params);
    yield put(getUserInfoSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(getUserInfoFailed(error.response));
  }
}

function* UserInfoSaga() {
  yield takeLatest(GET_USER_INFO, onGetUserInfo);
}

export default UserInfoSaga;
